@if((corporateTaxEntity$ | async) && (vpbBerekening$ | async)) {
  <div style="max-width: 80%">
    <form [formGroup]="belastbaarBedragFg">
      <div class="row">
        <div class="col col-1">
          <p>Belastbaar bedrag</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="belastbaarBedrag"
                                            id="belastbaarBedrag" prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>

    <form [formGroup]="belastingBerekeningFg">
      <div class="row">
        <div class="col col-1">
          <p>Belasting volgens normaal tarief</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="belastingNaarNormaalTarief"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>

    <form [formGroup]="belastingBedragFg">
      <div class="row">
        <div class="col col-1">
          <p>Af: aftrek elders belast</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control (change)="saveForm()"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="aftrekEldersBelast"
                                            id="aftrekEldersBelast"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>

      <div class="row">
        <div class="col col-1">
          <p>Af: te verrekenen dividendbelasting</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control (change)="saveForm()"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="dividendbelasting"
                                            id="dividendbelasting"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>

      @if((corporateTaxEntity$ | async)?.taxType === 'DA') {
        <div class="row">
          <div class="col col-1">
            <p>Af: te verrekenen kansspelbelasting</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="kansspelbelasting"
                                              id="kansspelbelasting"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      }
    </form>

    <form [formGroup]="belastingBedragFg">
      <div class="row">
        <div class="col col-1">
          <p>Af: te verrekenen voorlopige aanslagen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control (change)="saveForm()"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="voorlopigeAanslag"
                                            id="voorlopigeAanslag"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>

    <form [formGroup]="belastingBerekeningFg">
      <div class="row">
        <div class="col col-1">
          <p>Te betalen vennootschapsbelasting</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="verschuldigdeVennootschapsbelasting"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
  </div>
}
